import { I18N } from "oc-I18N";
import { useRef, useState } from "react";

export function ConfigurationCodeInput() {
  const inputRef = useRef<HTMLInputElement>();
  const [isInvalidCode, setIsInvalidCode] = useState<boolean>(false);

  function loadConfigurationCode() {
    const code = inputRef.current?.value;
    document.location.href =
      SETTINGS.configuratorUrl + (code == "" ? "" : "?Code=" + code.toUpperCase());
  }

  function checkCode() {
    const code = inputRef.current?.value?.toUpperCase();
    const isValid = code && /^[A-Z0-9]{10,10}$/.test(code);

    if (!isValid) {
      setIsInvalidCode(true);
      if (code === "") setIsInvalidCode(false);
    } else {
      loadConfigurationCode();
    }
  }

  function handleCodeSubmit() {
    checkCode();
  }

  function handleSubmitWithEnter(e: React.KeyboardEvent<HTMLElement>) {
    if (e.key === "Enter") {
      checkCode();
    }
  }

  return (
    <label className="configurationCodeInput" data-invalid={isInvalidCode}>
      <input
        ref={inputRef}
        placeholder={I18N("Konfigurationscode")}
        aria-label={I18N("aria::Konfigurationscode eingeben")}
        aria-invalid={isInvalidCode}
        data-input-key="configuration-code"
        onKeyDown={handleSubmitWithEnter}
      ></input>
      <div className="icon-wrapper">
        <button
          aria-label={I18N("aria::Submit Code")}
          data-button-key="code-laden"
          onClick={handleCodeSubmit}
          onKeyDown={handleSubmitWithEnter}
        >
          <span className={"icon-play-circle-o icon"}></span>
        </button>
      </div>
    </label>
  );
}
